// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".are-analysis-info[data-v-67181d71] {\n  margin-top: 25px;\n  font-size: 15px;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
